


import $ from 'jquery';

// scoped variables
var animationSpeed = 300;


export default function initHeader() {
	if ($("nav.mobNav").length) {
		mobMenuSetup();
	}

	if ($(".search").length) {
		searchSetup();
	}
}


/******************************************************
	Mobile Menu
******************************************************/
function mobMenuSetup() {
	// open menu event handler
	$(".header__menuIcon").on("click keyup", function (e) {
		if (e.which == "1" || e.which == "13") openMenu();
	});

	// close menu event handler
	$(".mobNav__close").on("click keyup", function (e) {
		if (e.which == "1" || e.which == "13") closeMenu();
	});

	// open sub menu
	$(".mobNav__subMenuList + .mobNav__menuLink").on("click keyup", function (e) {
		if (e.which == "1" || e.which == "13") {
			e.preventDefault();
			openSubMenu($(this));
		}
	});

	// close sub menu
	$(".mobNav__subMenuLink--back").on("click keyup", function (e) {
		if (e.which == "1" || e.which == "13") closeSubMenu();
	});

	// close menu once at desktop
	$(window).resize(function () {
		if (Foundation.MediaQuery.atLeast('large')) {
			closeMenu();
		}
	});
}

// open the mobile menu
function openMenu() {
	var timimg = 400;
	$("body").css({ overflowY: "hidden" });
	var $content = $("nav.mobNav").fadeIn(timimg).find(".mobNav__content");

	setTimeout(function () {
		Foundation.reInit("equalizer");
		$content.animate({ opacity: 1, marginTop: 0 }, timimg, function () {
			Foundation.Keyboard.trapFocus($('.mobNav'));
		});
	}, timimg * 0.5);
}

// open the sub menu
function openSubMenu(el) {
	el.siblings(".mobNav__subMenuList").addClass("open");
	el.closest(".mobNav__menuList").animate({ left: "-100%" }, function () {
		$(".mobNav__menuList").css({ visibility: "hidden" });
	});
}

// close the mobile menu
function closeMenu() {
	$("nav.mobNav").fadeOut(400, function () {
		Foundation.Keyboard.releaseFocus($('.mobNav'));
		$(this).find(".mobNav__content").attr({ style: "" });
		$("body").attr({ style: "" });
		closeSubMenu();
	});
}

// close the sub menu
function closeSubMenu() {
	$(".mobNav__menuList").css({ visibility: "visible" }).animate({ left: 0 }, function () {
		$(".mobNav__subMenuList.open").removeClass("open");
	});
}




/******************************************************
	Search bar
******************************************************/
function searchSetup() {
	
	$(".header__searchOpen").on("click keyup", function (e) {
		if (e.which == "1" || e.which == "13") openSearch();
	});

	$(".header__searchClose").on("click keyup", function (e) {
		if (e.which == "1" || e.which == "13") closeSearch();
	});
	
}

function openSearch() {
	$(".header__searchOpen").fadeOut(200, function () {
		$(".header__searchClose").fadeIn(200);
	});
	$(".search").slideDown(400, function () {
		$(".search__term").focus();
	});
	$(".main__overlay").show().animate({ opacity: 1 });
}


function closeSearch() {
	$(".header__searchClose").fadeOut(200, function () {
		$(".header__searchOpen").fadeIn(200);
	});
	$(".search").slideUp(400);
	$(".main__overlay").animate({ opacity: 0 }, function () {
		$(this).hide();
	});
}
